"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var styled_components_1 = __importStar(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\t", ";\n"], ["\n\tposition: relative;\n\t", ";\n"])), function (props) { return props.theme.select.container; });
var Label = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.select.label; });
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (selected) {
            _this.setState({ value: selected });
            if (_this.props.onChange) {
                if (!selected) {
                    _this.props.onChange(undefined);
                }
                else if (Array.isArray(selected)) {
                    _this.props.onChange(selected.map(function (s) { return s.value; }));
                }
                else {
                    _this.props.onChange(selected.value);
                }
            }
        };
        _this.state = {
            value: props.options.find(function (o) { return o.value === props.defaultValue; })
        };
        return _this;
    }
    Select.prototype.render = function () {
        return (react_1.default.createElement(Container, { "data-automationid": this.props.automationId },
            react_1.default.createElement(react_select_1.default, { placeholder: this.props.label, options: this.props.options, value: this.state.value, isDisabled: this.props.disabled, isSearchable: false, styles: this.props.theme.select.styles, onChange: this.onChange, "aria-label": this.props.label, "data-automationid": this.props.automationId }),
            this.props.label && this.state.value !== undefined &&
                react_1.default.createElement(Label, { disabled: this.props.disabled }, this.props.label)));
    };
    Select.defaultProps = {
        disabled: false,
        options: [{ label: '', value: '' }],
    };
    return Select;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Select);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Select.js.map